<template>
  <div class="container">
    <h1>About Me</h1>
    <p>I'm a currently a senior business analyst at Boeing and am looking to enter into a web development role.
      I have worked at Boeing for over 6 years and always visualized becoming part of the tech industry growing in my hometown of Seattle.</p>
      <p>I recently completed a web development certificate program at Seattle University and learned many front-end technologies and skills such as HTML, CSS, JavaScript, Bootstrap and Vue.js among others.<br></p>
      <p>My prior work experience allows me to understand office dynamics while still effectively working in teams to complete projects on time and increasing the efficiency of standard processes.</p><br>
      <p><a href="https://derekbenak.com/" target="_blank">My Portfolio</a></p>
      <p><a href="https://github.com/DerekJB1987" target="_blank">My Github Account</a></p>
  </div>
</template>

<script>
export default {
  name: "about-me"
};
</script>

<style scoped>
h1,{
  font-weight: normal;
}
p {
  font-size: 16px;
  text-align: center;
  display: block
}
</style>



